import { render, staticRenderFns } from "./SummaryInfo.html?vue&type=template&id=2ec10c7a&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryInfo.scss?vue&type=style&index=0&id=2ec10c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec10c7a",
  null
  
)

export default component.exports